import { render, staticRenderFns } from "./DecoratorLine.vue?vue&type=template&id=244fa79f&scoped=true"
import script from "./DecoratorLine.vue?vue&type=script&lang=js"
export * from "./DecoratorLine.vue?vue&type=script&lang=js"
import style0 from "./DecoratorLine.vue?vue&type=style&index=0&id=244fa79f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244fa79f",
  null
  
)

export default component.exports